import wordmark from '@/assets/brand/logo_name.png';
import { cn } from '@/lib/utils';

interface AppWordmarkProps {
  className?: string;
  hasLightSweep?: boolean | undefined;
}

export function AppWordmark({ className, hasLightSweep = false }: AppWordmarkProps) {
  const wordmarkImage = (
    <img src={wordmark} alt="" aria-hidden className={cn('h-4.5 w-auto shrink-0', className)} />
  );

  if (!hasLightSweep) {
    return wordmarkImage;
  }

  return (
    <span className="relative inline-flex shrink-0">
      {wordmarkImage}
      <span
        aria-hidden
        className="absolute inset-0 animate-light-sweep bg-linear-110 from-transparent from-42% via-white/60 via-50% to-transparent to-58% bg-size-[250%_100%] mask-contain mask-center mask-no-repeat motion-reduce:hidden"
        style={{ maskImage: `url(${wordmark})` }}
      />
    </span>
  );
}
